import { RJParser } from "../RJParser";
import { ConstantExpression } from "./ConstantExpression";
import { RJExpressionNode } from "./RJExpressionNode";

export abstract class ConstantExpressionFactory
{
  abstract create( parser:RJParser, nodes:RJExpressionNode[], index:number ):ConstantExpression<any>   
}